import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static get targets() {
        return ['trigger'];
    }

    triggerTargetConnected(element) {
        element.addEventListener('change', () => {
            this.element.submit();
        });
    }

    updateHidden(event) {
        const element = event.currentTarget;
        const input = document.querySelector(`input[name="${element.dataset.input}"]`);
        const value = element.value || element.dataset.value;

        input.value = value;

        if (element.dataset.submit === '1') {
            document.querySelector(element.dataset.form).submit();
        }
    }
}